import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { isTablet } from 'react-device-detect';
import Slider from 'react-slick';
import ThemeContext from '../../providers/ThemeProvider';
import FilterIconSelector from './FilterIconSelector';

export const FilterRecipient = ({
  currentFilter,
  filters,
  updateRecipient,
}) => {
  const theme = useContext(ThemeContext);
  const primaryColorUrlencoded = encodeURIComponent(theme.colors.primary);
  const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    lazyLoad: true,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3,
        },
      },
    ],

    slidesToScroll: isTablet ? 4 : 5,

    slidesToShow: isTablet ? 4 : 6,
    speed: 500,
  };

  return (
    <>
      {filters?.length > 0 && (
        <div className="filter-slider">
          <Slider {...settings}>
            {filters.map((filter) => {
              return (
                <FilterIconSelector
                  filter={filter}
                  isActive={currentFilter.id === filter.id}
                  key={`recipient-${filter.id}`}
                  selectFilter={updateRecipient}
                />
              );
            })}
          </Slider>
        </div>
      )}

      <style global jsx>{`
        .filter-slider {
          margin-bottom: 25px;
        }
        .filter-slider .slick-list {
          padding-top: 2px;
          z-index: 9;
        }
        .filter-slider .slick-next,
        .filter-slider .slick-prev {
          z-index: 10;
        }
        .filter-slider .slick-next {
          right: -20px;
        }
        .filter-slider .slick-prev {
          left: -20px;
        }
        @media only screen and (min-width: ${theme.breakpoints.mdUp}) {
          .filter-slider .slick-next,
          .filter-slider .slick-prev {
            top: 118px;
          }
        }
        @media only screen and (min-width: ${theme.breakpoints.lgUp}) {
          .filter-slider .slick-next,
          .filter-slider .slick-prev {
            top: 156px;
          }
        }
        .filter-slider .slick-next:before {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
        }
        .filter-slider .slick-prev:before {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'%3E%3Cpath fill='${primaryColorUrlencoded}' d='M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
        }
        .filter-slider .slick-next:before,
        .filter-slider .slick-prev:before {
          content: '';
          font-size: 15px;
          padding: 10px;
          height: 40px;
          width: 30px;
        }
      `}</style>
    </>
  );
};

FilterRecipient.propTypes = {
  currentFilter: PropTypes.object,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateRecipient: PropTypes.func.isRequired,
};
